/*
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-01 18:07:47
 * @FilePath: /Cup2Market/src/router/modules/goods.js
 * @Description: 
 */
export default [
  {
    path: "/goodsDetail/:id",
    name: "GoodsDetail",
    component: () => import("@/views/GoodsDetail"),
    meta: {
      roles: ["distributor", "customer"],
    },
  },
];
